import React from 'react';
import { Grow, Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SuccessPopover = ({ showSuccess, successMessage }) => {
  return (
    <Grow in={showSuccess} timeout={300} unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
        }}
      >
        <Box
          aria-live="polite"
          role="status"
          sx={{
            bgcolor: '#27ae60',
            color: 'white',
            px: 3,
            py: 2,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            minWidth: 200,
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 24 }} />
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {successMessage}
          </Typography>
        </Box>
      </Box>
    </Grow>
  );
};

export default SuccessPopover;
